import React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@material-ui/icons/Close';
import { LineItem } from '../../../services/fulfillment/types';
import { groupBinsByZone } from '../../../services/fulfillment/utils';

interface Props {
  item: LineItem | null;
  onClose: () => void;
}

export const InventoryLocationsDialog: React.FC<Props> = ({ item, onClose }) => (
  <Dialog open={!!item} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 700,
            color: 'grey.500',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
          }}
        >
          Inventory Locations
        </Typography>
        <Typography sx={{ fontSize: 16, fontWeight: 700 }}>{item?.sku ?? '—'}</Typography>
      </Box>
      <IconButton size="small" onClick={onClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
    <DialogContent sx={{ pt: 0 }}>
      {item &&
        (() => {
          const zoneGroups = groupBinsByZone(item.binLocations);
          if (zoneGroups.length === 0) {
            return (
              <Typography sx={{ fontSize: 13, color: 'grey.500', py: 1 }}>
                No inventory locations found.
              </Typography>
            );
          }
          return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 1 }}>
              {zoneGroups.map(group => (
                <Box key={group.zoneLabel}>
                  <Typography
                    sx={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: 'grey.500',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      mb: 0.75,
                    }}
                  >
                    {group.zoneLabel}
                  </Typography>
                  {group.bins.map(bin => (
                    <Box
                      key={bin.binCode}
                      sx={{
                        display: 'flex',
                        alignItems: 'baseline',
                        justifyContent: 'space-between',
                        py: 0.5,
                        borderBottom: '1px solid',
                        borderColor: 'grey.100',
                      }}
                    >
                      <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'grey.800' }}>
                        {bin.binCode}
                      </Typography>
                      <Typography sx={{ fontSize: 12, color: 'grey.500' }}>
                        qty {bin.quantity}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ))}
            </Box>
          );
        })()}
    </DialogContent>
  </Dialog>
);
